<template>
  <div class="h-100">
    <div class="loader-cont" v-dxloader="isLoader"></div>
    <div class="row h-100" v-show="!isLoader">
      <div class="content-wrapper-before gradient-45deg-indigo-purple"></div>
      <div class="breadcrumbs-dark pb-0 pt-4" id="breadcrumbs-wrapper">
        <!-- Search for small screen-->
        <div class="container">
          <div class="row">
            <div class="col s10 m6 l6 alignLeft">
              <h5 class="card-title alignLeft white-text">Services</h5>
            </div>
            <div class="col s10 m6 l6 alignRight">
              <a @click="$router.push({path: '/app/add-service'})" class="btn add_btn">
                <span>Add Service</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="col s12 p-0" style="height:calc(100% - 45px)">
        <div class="container p-0 h-100">
          <div class="section p-0 h-100">
            <div class="row m-0 h-100">
              <div class="col s12 m12 l12 p-0 h-100">
                <div class="card full-ht card card-default scrollspy mb-0 h-100">
                  <div class="card-content h-100">
                    <div class="row">
                      <div class="search-input col s7 m4 l4">
                        <div class="sidebar-search animate fadeUp">
                          <div class="search-area">
                            <i class="material-icons mr-2 search-icon">search</i>
                            <i
                              class="material-icons mr-2 close-icon"
                              v-show="filters.search"
                              @click="filters.search=''"
                            >close</i>
                            <input
                              type="text"
                              v-model="filters.search"
                              placeholder="Search Services"
                              class="app-filter"
                              id="chat_filter"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="category-select col s5 m4 l4">
                        <div class="input-field">
                          <select id="category" name="category" v-model="filters.category.id">
                            <option selected value>Choose Service Category</option>
                            <option
                              v-for="(catitem,index) in categoryList"
                              :key="index"
                              :value="catitem.id"
                            >{{catitem.name}}</option>
                          </select>
                          <!-- <label>Service Category</label> -->
                        </div>
                      </div>
                    </div>
                    <div class="row service-block">
                      <div v-for="cat in serviceList.results" :key="cat.id" class="col s12 m4 l4">
                        <div class="card" :class="{'inactive-cls' :!cat.is_active}">
                          <div class="inactive-block" v-if="!cat.is_active"></div>
                          <div
                            @click="goView(cat.id)"
                            class="card-image waves-effect waves-block waves-light"
                          >
                            <div class="carousel carousel-slider">
                              <a class="carousel-item">
                                <img class="activator" :src="cat.image" alt />
                              </a>
                            </div>
                          </div>
                          <div class="card-content alignLeft">
                            <span class="card-title activator grey-text text-darken-4">
                              <span @click="goView(cat.id)" class="title-span">{{cat.name}}</span>
                              <a class="dropdown-trigger" :data-target="'dropdown'+cat.id">
                                <i class="material-icons right fr">more_vert</i>
                              </a>
                              <ul :id="'dropdown'+cat.id" class="dropdown-content">
                                <!-- <li>
                                  <a @click="goView(cat.id)" class="-text pointer">View</a>
                                </li> -->
                                <li>
                                  <a @click="goEdit(cat.id)" class="-text pointer">Edit</a>
                                </li>
                                <li>
                                  <a
                                    @click="goDestroy(cat.id)"
                                    class="-text pointer"
                                  >{{cat.is_active ? 'Deactivate' : 'Activate'}}</a>
                                </li>
                              </ul>
                            </span>
                            <div @click="goView(cat.id)" class="alignLeft pointer more-contents">
                              <div class="service_type">
                                <span>{{cat.category}}</span>
                              </div>
                              <div class="ratings" v-if="cat.user_reviews && cat.rating>0">
                                <div class="star-rate">
                                  <span>
                                    {{cat.rating}}
                                    <i class="material-icons">star</i>
                                  </span>
                                  ({{cat.user_reviews ? cat.user_reviews.rating : ""}} ratings) & {{cat.user_reviews ? cat.user_reviews.review : ""}} reviews
                                </div>
                              </div>
                              <div class="service_cost" :class="{'pt-4' : cat.rating==0}">
                                <b>{{cat.basic_cost.cost}}</b>
                                <span>/ {{cat.basic_cost.value}}</span>
                              </div>
                              <div class="service_duration">
                                <!-- {{cat.duration}} -->
                                <span>
                                  <!-- | -->
                                  <i class="material-icons">people</i>
                                  <span class="booked">{{cat.count + ' have booked'}}</span>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      categoryList: [],
      isLoader: true,
      serviceList: {
        count: 0,
        previous: null,
        next: null,
        results: []
      },
      filters: {
        search: "",
        category: {
          id: ""
        }
      }
    };
  },
  created() {
    let url = Constants.default.APIURL.ListServices;
    this.listServices(url);
    this.listCategories();
    setTimeout(() => {
      Vue.scrollBottom($('.service-block'), () => {
        if (this.serviceList.next) {
          this.listServices(this.serviceList.next, 1);
        }
      });
    }, 500);
  },
  methods: {
    listServices(url, status = false) {
      ajax.get(
        url,
        res => {
          this.isLoader = false;
          let temp = this.serviceList.results;
          if (status) {
            this.serviceList = {
              count: res.data.count,
              previous: res.data.previous,
              next: res.data.next
            };
            this.serviceList.results = temp.concat(res.data.results);
          } else {
            this.serviceList = res.data;
          }
          if (this.serviceList.results.length == 0) {
            Vue.showNoDataBlock(".service-block");
          } else {
            Vue.hideNoDataBlock(".service-block");
          }
          setTimeout(() => {
            $(".carousel").carousel({
              fullWidth: true,
              indicators: true,
              noWrap: true
            });
            $(".dropdown-trigger").dropdown();
          }, 100);
        },
        err => {
          this.isLoader = false;
        }
      );
    },
    listCategories() {
      ajax.get(
        Constants.default.APIURL.ServiceCategory,
        res => {
          this.categoryList = res.data;
          setTimeout(() => {
            $("select").formSelect();
          }, 200);
        },
        err => {}
      );
    },
    goView(id) {
      this.$router.push({
        path: "service/" + id
      });
    },
    goEdit(id) {
      this.$router.push({
        path: "update-service/" + id
      });
    },
    goDestroy(id) {
      let url = Constants.default.APIURL.ListServices;
      ajax.delete(
        Constants.default.APIURL.ServiceDestroy + id,
        {},
        res => {
          let surl = Constants.default.APIURL.ListServices;

          this.listServices(surl);
        },
        err => {}
      );
    },
    searchFilter(q, category) {
      let url = Constants.default.APIURL.ListServices;
      if (q) {
        url += q;
      }
      if (category) {
        url += "&category=" + category;
      }
      this.listServices(url);
    }
  },
  watch: {
    filters: {
      handler: function() {
        this.searchFilter(this.filters.search, this.filters.category.id);
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
.category-select {
  .input-field {
    margin-top: 10px;
  }
}
.inactive-block {
  position: absolute;
  height: 100%;
  width: 100%;
  background: white;
  z-index: 10;
  opacity: 0.5;
}
.card {
  min-height: 355px !important;
  &.full-ht {
    min-height: -webkit-fill-available !important;
  }
  .card-title {
    font-size: 16px !important;
    margin-bottom: 0 !important;
    .dropdown-content {
      li > a {
        color: #183247;
        font-size: 13px;
        font-weight: 500;
      }
    }
  }
  .card-image {
    height: 50%;
  }
  .card-content {
    padding: 12px;
  }
  .card-action {
    display: flex;
    padding: 10px 20px !important;
  }
}
.carousel {
  height: 100% !important;
  min-height: 150px !important;
  .carousel-item {
    min-height: 150px !important;
  }
}

.dropdown-content {
  min-width: 125px;
}
.pt10 {
  padding-top: 20px !important;
}
.title-span {
  font-size: 100% !important;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: calc(100% - 30px);
  overflow: hidden;
  display: inline-block;
}
a.add_btn {
  margin-top: 10px;
  margin-right: 10px;
  span {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.service_type {
  font-family: SFProText;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  padding: 5px 0;
  font-size: 14px;
  span {
    background-color: #f4f6f8;
    border-radius: 4px;
    padding: 5px 10px;
  }
}
.inactive {
  opacity: 0.9;
  background: #f9e7e7 !important;
}
.service_cost {
  font-size: 15px;
  padding: 4% 5px 5px 0px;
  span {
    font-size: 14px;
  }
}
.service_duration {
  padding: 2% 5px 0px 0px;
  font-size: 14px;
  color: #666;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  i {
    position: absolute;
    font-size: 20px;
  }
  .booked {
    padding-left: 30px;
    display: inline-block;
  }
}
.btn-floating {
  position: absolute;
  right: 10px;
  top: 10px;
}
a.btn-cls {
  width: 100%;
  display: block;
  text-align: center;
}
.delbtn {
  right: 55px;
}
.right.fr {
  padding: 0;
  margin: 0;
}
.star-rate {
  i {
    float: right;
    font-size: 16px;
    padding-top: 2px;
    padding-left: 2px;
    color: #ffad46;
  }
  span {
    display: inline-block;
    font-weight: 600;
    color: #000;
  }
}
.ratings {
  font-weight: 500;
  font-size: 15px;
  padding: 12px 0px 0px 0px;
  color: #666;
}
.dropdown-trigger {
  display: inline-block;
  color: #666;
  position: absolute;
  right: 10px;
  z-index: 10;
  perspective: 10000px;
}

.search-input {
  .sidebar-search {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    padding: 1rem 0;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -moz-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .search-area {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    width: -webkit-calc(100% - 0rem);
    width: -moz-calc(100% - 0rem);
    width: calc(100% - 0rem);
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  i {
    font-size: 1.45rem;
    height: 41px;
    margin-right: 0 !important;
    padding: 0.75rem 0.25rem 0.35rem 0.75rem;
    color: #9e9e9e;
    border-radius: 5px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    background-color: #eceff1;
    &.close-icon {
      // display: none;
      position: absolute;
      right: 10px;
      cursor: pointer;
      font-size: 18px;
      top: 15px;
    }
  }
  .app-filter {
    height: 35px;
    margin-bottom: 0;
    padding: 0.2rem;
    color: #9e9e9e;
    border: none;
    border-radius: 5px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    background-color: #eceff1;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -moz-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    border-bottom: 0 !important;
    box-shadow: none !important;
  }
}

.service-block {
  padding-bottom: 24px;
  height: calc(100% - 57px);
  overflow: auto;
  .card {
    height: 360px;
  }
}
</style>

